import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDetails } from '../constants/modal-constants';
import { Router } from '@angular/router';
import { BallotTypes } from '../constants/toast-constants';
import { CreateSrsBallotModel } from '../../core/ballots/shared/models/sr/sr-committee-search-data';
import { SrsBallotService } from '../../core/ballots/shared/services/srs-ballot.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.scss',
    standalone: false
})
export class ModalComponent {
  @Input() modalHeader: string = ModalDetails.modalHeader;
  @Input() modalText: string = ModalDetails.modalText;
  @Input() simPublicationId: string = ``;

  createSrsBallotModel: CreateSrsBallotModel = {
    SimPublicationId: '',
    IsBallotAutoCreated: false,
    StartDate: null,
    EndDate: null,
    createCloseVoteBallot: true
  };

  constructor(public activeModal: NgbActiveModal, private router: Router, private _srsBallotService: SrsBallotService) {
  }

  confirm() {
    this.activeModal.dismiss('confirm');
    this.createSRSBallot();
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }

  createSRSBallot(){
      this.createSrsBallotModel.SimPublicationId = this.simPublicationId;
      try {
        this._srsBallotService.createSRSBallot(this.createSrsBallotModel).subscribe(
          (response) => {
            console.log(`response: ${response}`);
            if (response.success) {
              const ballotId = response.content;
              localStorage.setItem('fromDecisionModal', 'true');
              this.router.navigate([`/ballots/srs/${ballotId}`]);
            }

          },
        );
      } catch (error) {
        console.log(`error: ${error}`);
      }

    }



}
